var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "#FFEF25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1707 17.7643L20.122 42.2969H13.6382L24.6341 12.7034H28.7602L28.1707 17.7643ZM34.8577 42.2969L26.7886 17.7643L26.1382 12.7034H30.3049L41.3618 42.2969H34.8577ZM34.4919 31.2806V36.057H18.8618V31.2806H34.4919Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    transform: "translate(55 55)",
    fill: "#FFEF25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3824 68.4641H75.2796L82.4904 89.0747L89.7012 68.4641H94.5983L84.4569 96.5361H80.5238L70.3824 68.4641ZM67.741 68.4641H72.6189L73.5058 88.5541V96.5361H67.741V68.4641ZM92.3618 68.4641H97.259V96.5361H91.4749V88.5541L92.3618 68.4641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAm);
export default __webpack_public_path__ + "static/media/logo_am.c6ce01b47250b715f102e1194f2d9893.svg";
export { ForwardRef as ReactComponent };